<template>
	<div class="application-career--group">
		<div class="tag-sections">
			<section>
				<div class="title-container no-left-padding">
					<div>
						<Title
							:title="title"
							:editable="false"
							:deletable="true"
							:parent="true"
						/>
					</div>
					<a class="add-button" href="#" @click.prevent="openAddDialog">
						<Icon icon="plus"/>
					</a>
				</div>
				<div class="pl-3">
					<div v-if="!section && !hasItems" class="mt-3">
						Es sind noch keine Einträge vorhanden.
					</div>
					<template v-else>
						<template v-for="group in grouped">
							<div
								v-if="'sub-sections-title-' + group.title"
								:key="group.id"
								class="sub-sections-title no-left-padding"
							>
								{{ group.title }}
							</div>
							<div :key="'sub-sections-' + group.id" class="career-items">
								<div
									v-for="item in group.items"
									:key="item.id"
									class="career-item"
								>
									<div>
										<b-row>
											<b-col md="3">
												<template v-if="item.end">
													{{ item.start | dateByObject('LL/y') }} -
													{{ item.end | dateByObject('LL/y') }}
												</template>
												<template v-else-if="item.start">
													{{ item.start | dateByObject('LL/y') }} - aktuell
												</template>
												<template v-else>? - ?</template>
											</b-col>
											<b-col md="8">
												<template v-if="education">
													<div class="career-item-title">{{ getEducationTitle(item) }}</div>
													<div v-if="item.schoolType" class="career-item-subtitle">
														<Label :characteristic="item.schoolType"/>
													</div>
												</template>
												<template v-else>
													<div class="career-item-title">{{ getJobTitle(item) }}</div>
													<div v-if="item.title && item.title !== getJobTitle(item)"
														 class="career-item-subtitle">
														{{ item.title }}
													</div>
												</template>
												<div class="career-item-infos">
													<InfosEducation
														v-if="education"
														:education="item"
													/>
													<InfosJob
														v-else
														:job="item"
													/>
												</div>
											</b-col>
										</b-row>
									</div>
									<div>
										<a href="#" @click.prevent="editItem(item)">
											<Icon icon="pencil"/>
										</a>
										<a href="#" @click.prevent="$emit('removeItem', item)">
											<Icon icon="bin"/>
										</a>
									</div>
								</div>
							</div>
						</template>
					</template>
					<div class="my-3">
						<div v-if="!education">
							<!--<b-form-checkbox :checked="noFurther" @input="$emit('noFurtherChanged', $event)">
								{{ furtherTitle }}
							</b-form-checkbox>-->
						</div>
						<div v-if="section">
							<FormGroup :label="furtherTitle">
								<RadioGroup
									v-model="further"
									:options="furtherOptions"
									@input="furtherChanged"
								/>
							</FormGroup>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"
import Button from "@/vue/common/Button";
import {getMonthYearComparisonValue} from "@/helper/Date";
import {CAREER_EDUCATION, CAREER_EDUCATION_SCHOOL, hasTag} from "@/helper/characteristic/Tag";
import {mapActions} from "vuex";
import {byTag} from "@/helper/application/characteristic/Provider";
import FormGroup from "@/vue/common/form/Group.vue";
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import Title from "@/vue/common/profile-view/Title.vue";
import InfosEducation from "@/vue/application/profile/skills/InfosEducation.vue";
import InfosJob from "@/vue/application/profile/skills/InfosJob.vue";
import {isDefined} from "@/helper/Value";
import _ from "lodash";
import Label from "@/vue/characteristic/Label.vue";
import {isEmptyOrNull} from "@/helper/String";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

const FURTHER__YES = 'yes';
const FURTHER__NO = 'no';

export default {

	components: {
		Label,
		InfosJob,
		InfosEducation,
		Title,
		RadioGroup,
		FormGroup,
		Button,
		Icon,
	},

	props: {
		title: {
			type: String,
			required: true,
		},
		meta: {
			type: Object,
			required: true,
		},
		items: {
			type: Array,
			required: false,
		},
		education: {
			type: Boolean,
			required: false,
			default: false
		},
		section: {
			type: Object,
			required: false,
		},
		furtherTitleItems: {
			type: String,
			required: false,
		},
		furtherTitleNoItems: {
			type: String,
			required: false,
		}
	},

	data ()
	{
		let further = undefined;

		if (this.section && this.section.finished)
		{
			further = FURTHER__NO;
		}

		return {
			further,
		};
	},

	computed: {
		grouped ()
		{
			if (!this.education)
			{
				return [
					{id: 'job', items: this.sortedItems}
				];
			}

			let grouped = {};

			this.sortedItems.forEach(item =>
			{
				const key = hasTag(item.schoolType, CAREER_EDUCATION_SCHOOL)
					? 'school'
					: 'non-school';

				if (!grouped[key])
				{
					grouped[key] = {
						id: key,
						sort: key === 'school' ? 1 : 2,
						title: key === 'school'
							? 'Schulische Ausbildungen'
							: 'Weiterbildungen/Zusatzausbildungen',
						items: []
					};
				}

				grouped[key].items.push(item);
			});

			return _.sortBy(_.values(grouped), 'sort');
		},
		furtherTitle ()
		{
			return this.hasItems ? this.furtherTitleItems : this.furtherTitleNoItems;
		},
		furtherOptions ()
		{
			return [
				{value: FURTHER__YES, text: 'Ja'},
				{value: FURTHER__NO, text: 'Nein'},
			];
		},
		sortedItems ()
		{
			return this.items.sort((a, b) =>
			{
				const endMonthYearComparisonValueA = a.end ? getMonthYearComparisonValue(a.end.month, a.end.year) : null;
				const endMonthYearComparisonValueB = b.end ? getMonthYearComparisonValue(b.end.month, b.end.year) : null;

				if (endMonthYearComparisonValueA === endMonthYearComparisonValueB)
				{
					const startMonthYearComparisonValueA = a.start ? getMonthYearComparisonValue(a.start.month, a.start.year) : null;
					const startMonthYearComparisonValueB = b.start ? getMonthYearComparisonValue(b.start.month, b.start.year) : null;

					if (startMonthYearComparisonValueA === startMonthYearComparisonValueB)
					{
						return a.title.localeCompare(b.title);
					}

					if (!startMonthYearComparisonValueA && startMonthYearComparisonValueB)
					{
						return -1;
					}

					if (startMonthYearComparisonValueA && !startMonthYearComparisonValueB)
					{
						return 1;
					}

					return startMonthYearComparisonValueA > startMonthYearComparisonValueB ? -1 : 1;
				}

				if (!endMonthYearComparisonValueA && endMonthYearComparisonValueB)
				{
					return -1;
				}

				if (endMonthYearComparisonValueA && !endMonthYearComparisonValueB)
				{
					return 1;
				}

				return endMonthYearComparisonValueA > endMonthYearComparisonValueB ? -1 : 1;
			});
		},
		hasItems ()
		{
			return this.items && this.items.length > 0;
		},
	},

	methods: {
		...mapActions('application/education/fan', {
			showEducationFan: 'show'
		}),
		...mapActions('application/career/fan', {
			showCareerFan: 'show'
		}),
		getJobTitle (item)
		{
			if (item.companyName)
			{
				return item.companyName;
			}

			const title = item.title;

			return (title && !isEmptyOrNull(title)) ? title : item.careerType.label;
		},
		getEducationTitle (item)
		{
			let parts = [];

			if (item.title)
			{
				parts.push(item.title);
			}

			if (item.instituteName)
			{
				parts.push(item.instituteName);
			}

			if (parts.length === 0)
			{
				parts.push(item.schoolType.label);
			}

			return parts.join(' | ');
		},
		furtherChanged (value)
		{
			if (value === FURTHER__YES)
			{
				this.openAddDialog();
				return;
			}

			if (value === FURTHER__NO)
			{
				this.$emit('finished');
			}
		},
		openAddDialog ()
		{
			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_VITA)
					.setAction('Hinzufügen')
					.setName(this.education ? 'Ausbildung' : 'Berufserfahrung')
			);

			if (this.education)
			{
				this.editEducation();

				return;
			}

			this.editCareer();
		},
		editItem (item)
		{
			Event.push(
				new EventData()
					.setEvent(Event.APPLICANT_VITA)
					.setAction('Bearbeiten')
					.setName(this.education ? 'Ausbildung' : 'Berufserfahrung')
			);

			if (this.education)
			{
				this.editEducation(item);

				return;
			}

			this.editCareer(item);
		},
		editEducation (education)
		{
			this.showEducationFan({
				title: education ? 'Ausbildung/Weiterbildung bearbeiten' : 'Ausbildung/Weiterbildung hinzufügen',
				education,
				withSchoolTypeSelection: !isDefined(education?.schoolType),
				onClose: (data) =>
				{
					this.further = this.section?.finished ? FURTHER__NO : undefined;

					if (!data?.education || !data.confirm)
					{
						return;
					}

					let newEducation = data.education;

					newEducation.careerType = byTag(this.meta.careerType, CAREER_EDUCATION);

					this.$emit('saveItem', newEducation);
				}
			});
		},
		editCareer (career)
		{
			this.showCareerFan({
				career,
				onClose: (data) =>
				{
					if (!data?.career || !data.confirm)
					{
						return;
					}

					let newCareer = data.career;

					newCareer.type = 'job';

					this.$emit('saveItem', newCareer);
				}
			});
		},
		save (item)
		{
			this.$emit('saveItem', item);
		},
	}
}
</script>
